import { render, staticRenderFns } from "./SubmissionPage.vue?vue&type=template&id=18221838&"
import script from "./SubmissionPage.vue?vue&type=script&lang=js&"
export * from "./SubmissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports